<template>
  <div class="box">
    <div class="select">
      <div class="searchBox">
        <img src="../../../../assets/image/sousuo_ic_daoyou @2x (1).png"/>
        <img v-if="searchName" @click="cancel" src="../../../../assets/appointment/ic_close_sousuo@3x.png"/>
        <input type="text" v-model="searchName" placeholder="请输入资源单体名称" />
      </div>
    </div>
    <div v-if="showNone1">
      <div class="box2" v-if="showNone">
          <!-- v-model="loading" -->
        <van-list
          :finished="finished"
          :finished-text="finishedText"
          :immediate-check="false"
          :v-load="onLoad"
        >
          <ul>
            <li
              class="line_bottom"
              v-for="(item,index) in filterList"
              :key="index"
              @click="goScoreDetails(item)"
            >
              <div class="score">
                <div class="left">
                  <div
                    class="businessName"
                    :class="{businessNameWidth: !item.isBlackList && !item.isSupervision}"
                  >
                    <span>{{item.monomerName.slice(0, item.monomerName.indexOf(searchName))}}</span>
                    <span
                      class="highlight"
                    >{{item.monomerName.slice(item.monomerName.indexOf(searchName),item.monomerName.indexOf(searchName)+searchName.length)}}</span>
                    <span>{{item.monomerName.substr(item.monomerName.indexOf(searchName)+searchName.length)}}</span>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </van-list>
      </div>
    </div>
    <div class="tipsBox" v-if="isShowTips">
      <img class="tipsImgBox" src="../../../../assets/image/ic_wusousuo@3x.png" alt />
      <p class="tipsText">当前搜索无结果</p>
      <p>请核对信息后进行搜索</p>
    </div>
  </div>
</template>
<script>
import api from "../../../../service/modules/resourcesManage";
export default {
  data() {
    return {
      // loading: false,
      finished: false,
      finishedText: "",
      searchName: "",
      pageSize: 20,
      pageIndex: 1,
      dataList: [], // 获取数据
      filterList: [],
      showNone: false,
      showNone1: false,
      type: "all",
      isShowTips: false
    };
  },
  watch: {
    searchName(val) {
      this.pageIndex = 1;
      this.searchName = val;
      if (val === "") {
        this.showNone1 = false;
      } else {
        this.showNone1 = true;
      }
      if (val === "") {
        this.isShowTips = false;
      }
      this.dataList = [];
      this.queryOrgAndTravelAgencyList();
    }
  },
  methods: {
    // 获取检索接口数据
    queryOrgAndTravelAgencyList() {
      let params = {
        // areaCode: this.$route.query.areaCode,
        // regionLevel: this.$route.query.regionLevel,
        monomerName: this.searchName,
        regionId: this.$route.query.regionId
      };
      // this.loading = false;
      api.getDirectories(params).then(res => {
        this.filterList = [];
        if (res.ret === 0) {
          // this.loading = false;
          if (res.data.list.length > 0) {
            res.data.list.forEach(element => {
              if (element.monomerName.indexOf(this.searchName) != -1 && this.searchName!='') {
                this.filterList.push(element);
                // this.loading = false;
              }
            });
            this.showNone = true;
          }
        }
      });
    },
    cancel () {
      this.searchName = '';
    },
    onLoad() {
      this.queryOrgAndTravelAgencyList();
    },
    goScoreDetails(e) {
      this.$router.replace({
        path: '/resourcesManage/directories',
        query: {
            areaCode: this.$route.query.areaCode,
            regionLevel: this.$route.query.regionLevel,
            monomerName: e.monomerName,
            name: this.$route.query.name
        }
      })
    },
  }
};
</script>
<style lang="less" scoped>
.van-search {
  padding: 12px 16px;
}
.box {
  width: 100%;
  height: 100%;
  background: #fff;
  box-sizing: border-box;
  .select {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 60px;
    line-height: 60px;
    background: #fff;
    z-index: 999;
  }
  .searchBox {
      height: 36px;
      line-height: 36px;
      margin: 12px 16px 0 16px;
      background-color: #fff;
      border: 1px solid #eee;
      border-radius: 3px;
      box-sizing: border-box;
      position: relative;
      font-size: 14px;

      > img:nth-child(1) {
        display: inline-block;
        width: 14px;
        height: 14px;
        position: absolute;
        top: 10px;
        left: 14px;
      }

      > img:nth-child(2) {
        display: inline-block;
        width: 14px;
        height: 14px;
        position: absolute;
        top: 10px;
        right: 14px;
      }

      > input {
        font-family: PingFang SC;
        width: 100%;
        height: 28px;
        line-height: 28px;
        padding: 0 16px 0 40px;
        box-sizing: border-box;
        border-radius: 2px;
        background-color: #fff;
      }
      input::-webkit-input-placeholder {
        color: #999999;
      }
      input::-moz-input-placeholder {
        color: #999999;
      }
      input::-ms-input-placeholder {
        color: #999999;
      }
    }
  .line_bottom::after {
    background-color: transparent;
  }
  .box2 {
    width: 100%;
    height: 100%;
    padding: 70px 16px 12px 16px;
    // padding-top: 58px;
    ul {
      width: 100%;
      background-color: #fff;
      li:last-child {
        border-bottom: none;
      }
      li {
        list-style: none;
        box-sizing: border-box;
        padding: 11px 0;
        font-size: 14px;
        overflow: hidden;
        .score {
          color: #333;
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-weight: Medium;
          overflow: hidden;
          .left {
            display: flex;
            justify-content: left;
            align-items: center;
            .businessName {
              line-height: 18px;
              font-size: 14px;
              font-weight: 400;
              max-width: 200px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              .highlight {
                color: @base-color;
                font-weight: 400;
              }
            }
            .businessNameWidth {
              max-width: 260px;
            }
            .tag {
              line-height: 18px;
              font-size: 12px;
              height: 18px;
              margin-left: 4px;
              -webkit-transform: scale(0.84);
              margin: 0px 3px 0 3px;
              padding: 0 3px 2px 3px;
              text-align: center;
              color: #ff4d4d;
            }
            .callout {
              display: inline-block;
              height: 18px;
              line-height: 18px;
              margin-top: -1px;
              margin-left: 4px;
              padding: 0 8px;
              box-sizing: border-box;
              // border: 1px solid #ff4d4d;
              color: #ff4d4d;
              font-size: 10px;
              font-weight: Regular;
            }
          }
          .right {
            font-size: 14px;
            font-weight: 600;
            line-height: 16px;
          }
        }
      }
    }
  }
  .tipsBox {
    width: 140px;
    color: #999999;
    font-size: 14px;
    text-align: center;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    .tipsImgBox {
      width: 74px;
      height: 62px;
      margin: 0 auto;
      margin-bottom: 15px;
      display: block;
    }

    .tipsText {
      margin-bottom: 10px;
      // font-family: PingFangSC-Regular, PingFang SC;
      font-size: 14px;
    }
  }
}
</style>

<style lang="less">
.van-search--show-action {
  background: #fff;
}
.van-search__content {
  border: 1px solid #eeeeee;
  background: #fff;
  .van-search--show-action {
    padding-right: 40px !important;
  }
}
.van-search__action {
  padding: 0 8px 0 20px;
}
</style>

